// src/firebase/config.js
// ─────────────────────────────────────────────────────────────────────────────
// SETUP: Replace these values with your Firebase project credentials.
// Go to: Firebase Console → Project Settings → Your apps → Web app → Config
// ─────────────────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDCAYCNwm9dcMovjjKO2-Bj2RKopq4mrbg",
  authDomain: "pankajlifewellness.firebaseapp.com",
  databaseURL: "https://pankajlifewellness-default-rtdb.firebaseio.com",
  projectId: "pankajlifewellness",
  storageBucket: "pankajlifewellness.firebasestorage.app",
  messagingSenderId: "99646889323",
  appId: "1:99646889323:web:c75e013392b67e8ecd802e",
  measurementId: "G-P94MSM44BX"
};

const app = initializeApp(firebaseConfig);

export const auth     = getAuth(app);
export const firestore = getFirestore(app);   // Firestore    → student profiles
export const storage  = getStorage(app);      // Storage      → face images

export default app;
